module.exports = __webpack_public_path__ + "img/photo_2022-11-09_18-32-25.2e5a4e76.jpg";